<template>
  <div class="content">
    <el-card class="account-profile-card" style="max-width: none">
      <template #header>
        <div class="card-header">
          <span>资料设置</span>
        </div>
      </template>

      <div class="account-action account-action--avatar">
        <div class="account-action__icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <circle cx="12" cy="12" r="9" />
            <circle cx="12" cy="10" r="3" />
            <path d="M7 19c1.5-2.5 3.2-3.5 5-3.5s3.5 1 5 3.5" />
          </svg>
        </div>
        <div class="account-action__main">
          <div class="account-action__title">头像</div>
          <div class="account-action__desc">点击头像可上传更换</div>
        </div>
        <UserAvatar editable :size="56" />
      </div>

      <div class="account-safety-divider" />

      <div class="account-action">
        <div class="account-action__icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <circle cx="12" cy="8" r="4" />
            <path d="M5 20c0-4 3.5-6 7-6s7 2 7 6" />
          </svg>
        </div>
        <div class="account-action__main">
          <div class="account-action__title">昵称</div>
          <div class="account-action__value">{{ displayName }}</div>
        </div>
        <el-button class="account-action__btn" @click="handleEditNickname">
          修改
        </el-button>
      </div>

      <div class="account-safety-divider" />

      <div class="account-action">
        <div class="account-action__icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path
              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
            />
          </svg>
        </div>
        <div class="account-action__main">
          <div class="account-action__title">手机号</div>
          <div class="account-action__value">{{ displayPhone }}</div>
        </div>
        <el-button class="account-action__btn" @click="handleEditPhone">
          更换
        </el-button>
      </div>
    </el-card>

    <el-card class="account-safety-card" style="max-width: none">
      <template #header>
        <div class="card-header">
          <span>安全与账号</span>
        </div>
      </template>

      <div class="account-action account-action--logout">
        <div class="account-action__icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </div>
        <div class="account-action__main">
          <div class="account-action__title">退出登录</div>
          <div class="account-action__desc">
            退出当前账号，再次使用需重新登录
          </div>
        </div>
        <el-button class="account-action__btn" @click="logout">
          退出登录
        </el-button>
      </div>

      <div class="account-safety-divider" />

      <div class="account-action account-action--danger">
        <div
          class="account-action__icon account-action__icon--danger"
          aria-hidden="true"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path d="M3 6h18" />
            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
          </svg>
        </div>
        <div class="account-action__main">
          <div class="account-action__title">账号注销</div>
          <div class="account-action__desc">
            注销后账号与数据将不可恢复，请谨慎操作
          </div>
        </div>
        <el-button
          class="account-action__btn account-action__btn--danger"
          type="danger"
          plain
          @click="openDeactivateDialog"
        >
          注销账号
        </el-button>
      </div>
    </el-card>
  </div>

  <el-dialog
    v-model="showDeactivateDialog"
    title="账号注销"
    width="min(560px, 92vw)"
    class="deactivate-dialog"
    destroy-on-close
    @closed="resetDeactivateForm"
  >
    <div class="deactivate-panel">
      <div class="deactivate-panel__alert">
        请注意，账号注销后将不可逆！请谨慎执行！
      </div>
      <div class="deactivate-panel__terms">
        <p v-for="(item, index) in deactivateTerms" :key="index">
          {{ item }}
        </p>
      </div>
      <el-checkbox
        v-model="checked1"
        class="deactivate-panel__check"
        label="我已认真阅读并同意上述条款"
      />
    </div>
    <template #footer>
      <div class="deactivate-dialog__footer">
        <el-button @click="showDeactivateDialog = false">取消</el-button>
        <el-button type="danger" :disabled="!checked1" plain>
          确认注销
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { computed, inject, ref } from "vue";
import { useUserStore } from "@/stores/user";
import UserAvatar from "@/components/UserAvatar.vue";

const userStore = useUserStore();
const profileEdit = inject("profileEdit", null);

const userInfo = computed(() => userStore.userInfo);

const displayName = computed(() => userInfo.value?.username || "未设置昵称");

const displayPhone = computed(() => {
  const phone = userInfo.value?.phone;
  if (!phone) return "未绑定手机号";
  return phone;
});
// const sureRealname = ref(false); //是否确认实名
// const active = ref(0);
const checked1 = ref(false);
const showDeactivateDialog = ref(false);

const handleEditNickname = () => {
  profileEdit?.openNicknameDialog?.();
};

const handleEditPhone = () => {
  profileEdit?.openPhoneDialog?.();
};

const openDeactivateDialog = () => {
  showDeactivateDialog.value = true;
};

const resetDeactivateForm = () => {
  checked1.value = false;
};

const deactivateTerms = [
  "（1）在您继续注销流程之前，请确保您确实希望注销您的账户。一旦您完成注销流程，您的账户和所有相关数据将被永久删除，且无法恢复。",
  "（2）我们建议您在注销账户之前备份您账户中的所有重要数据，包括但不限于个人信息、通信记录和已上传的文件。",
  "（3）您需要通过您的账户设置界面提交注销请求。在提交请求后，我们将向您的注册邮箱发送一封确认邮件。",
  "（4）请在收到确认邮件后的 7 个工作日内点击确认链接以完成注销流程。如果您未在规定时间内完成确认，注销请求将被取消。",
  "（5）为了验证您的身份，我们可能需要您输入账户密码。",
  "（6）请注意，根据适用的法律和隐私政策，某些数据可能需要在服务器上保留一段时间，即使您的账户已被注销。",
  "（7）注销账户并不免除您遵守我们服务条款和隐私政策的义务。您应继续遵守所有适用的条款和条件，直至账户完全注销。",
  "（8）在您的账户被完全注销之前，您可以随时取消注销请求。",
  "（9）一旦您的账户被注销，我们将不再向您发送任何通知或更新。",
  "（10）账户一旦注销，将无法重新激活。如果您希望使用我们的服务，您需要重新注册一个新账户。",
  "（11）如果您的账户与第三方服务有关联，您需要自行解除这些关联。",
  "（12）在您注销账户后，我们不对任何第三方未经授权的访问或数据泄露承担责任。",
  "（13）我们保留随时修改这些注销条款的权利。任何变更将通过我们的网站公布。",
];

const logout = () => {
  userStore.logout();
};
// const handleRealname = (val) => {
//   hasRealname.value = val;
//   if (active.value++ > 2) active.value = 0;
// };
// const handleSureRealname = (val) => {
//   sureRealname.value = val;
// };

// const next = () => {
//   if (active.value++ > 2) active.value = 0;
// };
</script>
<style lang="scss" scoped>
.content {
  padding: 0;
  margin: 0;
  max-width: none;
  .top {
    display: flex;
    .title {
      font-family: Source Han Sans;
      font-size: 24px;
      font-weight: 350;
      color: rgba(37, 37, 35, 0.5);
      cursor: pointer;
      margin-right: 18px;
    }
    .active {
      color: #000;
    }
  }
}
.card-header {
  font-size: 17px;
  font-weight: 600;
  color: var(--ux-text-primary);
  letter-spacing: -0.02em;
}

.account-profile-card {
  margin-bottom: 20px;
}

.account-safety-card {
  margin-top: 0;
}

.account-action {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 0;
}

.account-action--danger {
  margin-top: 0;
}

.account-action__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: var(--ios-radius-md, 14px);
  background: var(--ux-glass-bg-subtle);
  border: 0.5px solid var(--ux-glass-border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ux-text-secondary, #9fb4d6);

  svg {
    width: 22px;
    height: 22px;
  }
}

.account-action__icon--danger {
  color: #f87171;
  background: rgba(248, 113, 113, 0.1);
  border-color: rgba(248, 113, 113, 0.25);
}

.account-action__main {
  flex: 1;
  min-width: 0;
}

.account-action__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ux-text-primary);
  line-height: 1.35;
}

.account-action__desc {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--ux-text-secondary, #9fb4d6);
}

.account-action__value {
  margin-top: 4px;
  font-size: 15px;
  line-height: 1.45;
  color: var(--ux-text-primary);
  word-break: break-word;
}

.account-action--avatar {
  align-items: center;
}

.account-action__btn {
  flex-shrink: 0;
  min-width: 100px;
}

.account-safety-divider {
  height: 0.5px;
  margin: 20px 0;
  background: var(--ux-glass-border, var(--ios-separator));
}

.account-action__btn--danger {
  min-width: 100px;
}

.deactivate-panel {
  padding: 0;
  margin-top: 0;
  border: none;
  background: transparent;
}

.deactivate-panel__alert {
  padding: 12px 14px;
  border-radius: var(--ios-radius-sm, 10px);
  background: rgba(248, 113, 113, 0.12);
  border: 0.5px solid rgba(248, 113, 113, 0.28);
  color: #fca5a5;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.45;
  margin-bottom: 16px;
}

.deactivate-panel__terms {
  max-height: 220px;
  overflow-y: auto;
  padding: 14px 16px;
  border-radius: var(--ios-radius-sm, 10px);
  background: rgba(0, 0, 0, 0.12);
  border: 0.5px solid var(--ux-glass-border);
  margin-bottom: 16px;
  -webkit-overflow-scrolling: touch;

  p {
    margin: 0 0 12px;
    font-size: 14px;
    line-height: 1.55;
    color: var(--ux-text-secondary, #9fb4d6);

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.deactivate-panel__check {
  display: flex;
  width: 100%;
  margin-bottom: 0;
}

.deactivate-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 640px) {
  .account-action {
    flex-wrap: wrap;
  }

  .account-action__btn {
    width: 100%;
    margin-left: 60px;
  }

  .account-action__btn--danger {
    margin-left: 60px;
  }

  .deactivate-dialog__footer {
    justify-content: stretch;

    .el-button {
      width: 100%;
    }
  }
}
.login_content {
  .title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 350;
    // margin-top: 34px;
  }
  .phone {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }
  .password {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }
  .left {
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    color: var(--ux-text-primary);
    // opacity: 0.5;
    width: 70px;
  }
  .mid {
    width: 284px;
    height: 38px;
    // border: none;
    // border-radius: 10px;
    // background: rgba(217, 217, 217, 0.3);
    margin-right: 46px;
  }
  .right {
    margin-left: 20px;
    // width: 99px;
    // height: 38px;
    border-radius: 10px;
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    // line-height: 38px;
    color: var(--ux-text-primary);
    cursor: pointer;
    background: var(--ux-glass-bg-subtle);
    p {
      opacity: 0.5;
    }
  }
  .pic {
    display: flex;
    width: 630px;
    flex-wrap: wrap;
    margin-top: 34px;
    .pic_item {
      width: 282px;
      height: 178px;
      opacity: 0.5;
      background: var(--ux-glass-bg);
      margin-right: 27px;
      margin-bottom: 22px;
      text-align: center;
      line-height: 178px;
      font-family: Source Han Sans;
      font-size: 18px;
      font-weight: 350;
      cursor: pointer;
    }
  }
  .submit {
    // float: left;
    width: 99px;
    height: 58px;
    line-height: 58px;
    // border-radius: 10px;
    // opacity: 0.3;
    // background: var(--ux-surface-muted);
    // font-family: Source Han Sans;
    font-size: 20px;
    font-weight: normal;
    text-align: center;
    cursor: pointer;
  }
  .hasRealnameTip {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 300px;
    .tip {
      opacity: 0.5;
      font-family: Source Han Sans;
      font-size: 30px;
      font-weight: 350;
    }
    .sure {
      width: 99px;
      height: 58px;
      line-height: 58px;
      border-radius: 10px;
      text-align: center;
      background: var(--ux-surface-muted);
      margin-top: 60px;
      opacity: 0.5;
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: normal;
      cursor: pointer;
    }
  }
  .submit_change {
    width: 162px;
    height: 58px;
    line-height: 58px;
    border-radius: 10px;
    opacity: 0.5;
    font-family: Source Han Sans;
    font-size: 20px;
    font-weight: normal;
    background: var(--ux-surface-muted);
    text-align: center;
    cursor: pointer;
    margin-top: 20px;
  }
}
.my-info {
  display: flex;
  justify-content: space-between;

  .icon-btn {
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .icon-text {
    font-size: 20px;
    font-weight: bold;
    line-height: 23.4px;
    color: var(--ux-text-primary);
    cursor: pointer;
  }

  .top_left {
    .userInfo {
      display: flex;
      align-items: center;

      :deep(.user-avatar) {
        margin-right: 14px;
      }

      .info {
        .username {
          width: 99px;
          height: 38px;
          line-height: 38px;
          border-radius: 10px;
          opacity: 0.5;
          text-align: center;
          background: var(--ux-surface-muted);
          color: var(--ux-text-primary);
          font-size: 16px;
          margin-top: 25px;
          cursor: pointer;
        }

        .id {
          font-weight: 400;
          font-size: 16px;
          color: var(--ux-text-primary);
          line-height: 19px;
          font-style: normal;
          text-transform: none;
          margin-top: 4px;
        }

        .block-address {
          font-size: 14px;
          font-weight: 350;
          line-height: 16.38px;
          text-align: center;
          display: flex;
          align-items: center;
          letter-spacing: 0px;
          cursor: pointer;
          color: #585858;
          margin-top: 4px;
        }
      }

      .icon-group {
        display: flex;
        height: 30px;
        margin-left: 17px;
      }
    }

    .vr-coin {
      p {
        margin-left: 47px;
        margin-top: 13px;
        margin-bottom: 6px;
      }

      .vr-content {
        display: flex;
        align-items: center;
      }

      .vr-input {
        margin: 0 6px;
        width: 179px;

        &::v-deep .el-input__wrapper {
          border-radius: 6px !important;
        }
      }
    }
  }
}
</style>
